import React from 'react'

/* package */
import { SectionWrappList } from '../../lib-atomic-section'
/* package */

/* container */
import ContentContainer from '../../app-content-container/default'
/* container */

/* form */
import Content from '../layout/content'
/* form */

const index = (props) => {
  return (
    <ContentContainer.ContentList {...props}>
      <SectionWrappList {...props}>
        <Content {...props} />
      </SectionWrappList>
    </ContentContainer.ContentList>
  )
}

export default index
